export const moneycontrolDomain = 'moneycontrol.hbits.co';